import React from 'react';
import { Chip, Typography, Box } from '@mui/material';

export const FunctionCatalogChips = ({ catalog, onSelect }) => {
  const catalogEntries =
    catalog && typeof catalog === 'object' && !Array.isArray(catalog)
      ? Object.entries(catalog)
          .map(([category, functions]) => {
            if (Array.isArray(functions)) {
              return [category, functions];
            }

            if (Array.isArray(functions?.functions)) {
              return [category, functions.functions];
            }

            return [category, []];
          })
          .filter(([, functions]) => functions.length > 0)
      : [];

  if (catalogEntries.length === 0) {
    return null;
  }
  return (
    <Box>
      {catalogEntries.map(([category, functions]) => (
        <Box key={category} mb={2}>
          <Typography variant="subtitle2" gutterBottom>
            {category}
          </Typography>
          <Box display="flex" flexWrap="wrap" gap={1}>
            {functions.map((fn) => (
              <Chip
                key={fn.name}
                label={fn.label}
                onClick={() => onSelect && onSelect(fn)}
                title={fn.description}
                color="primary"
                variant="outlined"
                clickable
              />
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};
